import { Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const CustomTable = ({
  loading,
  rows,
  columns,
  isServerSidePagination = false,
  paginationModel,
  setPaginationModel,
  rowCount,
  onRowClick,
  isRowColored = true,
}) => {
  const slots = {
    noRowsOverlay: () => (
      <Grid width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
        <Typography variant="body2">No records found</Typography>
      </Grid>
    ),
  };

  const handleCellClick = (params) => {
    const clickedField = params.field;

    if (clickedField !== 'action') {
      onRowClick(params.row);
    }
  };

  const addClassName = (row) => {
    let statusClassName = '';
    switch (row.status) {
      case 'Pending Review':
        statusClassName = 'blue-out';
        break;
      case 'Rejected':
        statusClassName = 'red-out';
        break;
      case 'Upcoming': {
        let currentDate = new Date();
        let dateTime = new Date(row.dateTime);
        let check = currentDate > dateTime;
        if (check) {
          statusClassName = 'blinkRed';
        } else {
          statusClassName = '';
        }
        break;
      }
      case 'Wrapping Up':
        statusClassName = 'blinkGreen';
        break;
      case 'In Progress':
        statusClassName = 'rollingGreen';
        break;
      default:
        statusClassName = 'greyed-out';
    }
    return statusClassName;
  };

  const pageSizeOptions = [25, 50, 100];
  return (
    <>
      {isServerSidePagination ? (
        <DataGrid
          sx={{
            '.MuiDataGrid-columnHeaders': {
              color: '#2065D1',
            },
            minHeight: loading ? '60vh' : 'auto',
          }}
          onCellClick={onRowClick && handleCellClick}
          getRowClassName={isRowColored && ((params) => addClassName(params.row))}
          rows={rows}
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          getRowId={(row) => row._id}
          columns={columns}
          pagination
          loading={loading}
          paginationModel={paginationModel}
          pageSizeOptions={pageSizeOptions}
          rowCount={rowCount}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          slots={slots}
        />
      ) : (
        <DataGrid
          rows={rows}
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          getRowId={(row) => row._id}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: pageSizeOptions[0] },
            },
          }}
          pageSizeOptions={pageSizeOptions}
          slots={slots}
        />
      )}
    </>
  );
};

export default CustomTable;
